import styled from 'styled-components';

import colors from '~/styles/colors';

interface DateRangeProps {
  hideCalendar?: boolean;
  disableRangeSelect?: boolean;
}

export const Container = styled.div<DateRangeProps>`
  margin-top: 8px;
  display: flex;
  flex-direction: column;

  .rdrMonth {
    width: auto;
  }

  .rdrMonthAndYearWrapper {
    display: ${({ hideCalendar }) => (hideCalendar ? 'none' : 'inherit')};
  }

  .rdrMonthsVertical {
    display: ${({ hideCalendar }) => (hideCalendar ? 'none' : 'inherit')};
    height: 100%;
  }

  .rdrDateDisplayItemActive {
    input {
      border-color: #b3b3b3 !important;
    }
  }

  .rdrDateDisplayWrapper {
    background: transparent;
    width: 100%;
  }

  .rdrDateDisplayItem {
    box-shadow: none;
  }

  .rdrDateDisplay {
    display: grid;
    margin: 8px 0;
    grid-template-columns: 1fr 1fr;

    input {
      border-radius: 5px;
      border: 1px solid ${colors.gray};
    }
  }

  .rdrDateDisplayItemActive {
    border: none;
    input {
      border-radius: 5px;
      border-color: ${colors.primary};
    }
  }

  .rdrDateInput {
    width: auto;
  }

  .rdrDayNumber span {
    color: ${colors.darkgray};
    font-weight: 400;
  }

  .rdrDayPassive .rdrDayNumber span {
    font-weight: 300;
  }

  .rdrDays {
    .rdrDayToday .rdrDayNumber span {
      font-weight: 600 !important;

      :after {
        background: ${colors.primary};
      }
    }

    .rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
    .rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
    .rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
    .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
      color: ${({ disableRangeSelect }) =>
        disableRangeSelect ? colors.darkgray : colors.white};
    }
  }

  .rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span:after,
  .rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span:after {
    background: ${colors.primary};
  }
`;

export const ErrorSpan = styled.span`
  color: #c11e1e;
  margin: 5px 0;
`;
